import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { AppNavigationItem } from './app-navigation-item.model';
import { RequiredScopes } from './required-scopes.model';

export const untranslatedNavigationItems: AppNavigationItem[] = [
  {
    label: _('i18n.Shift.List.Title'),
    link: 'shifts',
    icon: 'punch_clock',
    [RequiredScopes]: ['shifts:read'],
  },
  {
    label: _('i18n.Deployment.List.Title'),
    link: 'deployments',
    icon: 'assignment',
    [RequiredScopes]: ['deployments:read'],
  },
  {
    label: _('i18n.Vehicle.List.Title'),
    link: 'vehicles',
    icon: 'local_shipping',
    [RequiredScopes]: ['vehicles:read'],
  },
  {
    label: _('i18n.VehiclePlanning.List.Title'),
    link: 'vehicleplanning',
    icon: 'departure_board',
    [RequiredScopes]: ['deployments:read'],
  },
  {
    label: _('i18n.Driver.List.Title'),
    link: 'drivers',
    icon: 'person',
    [RequiredScopes]: ['drivers:read'],
  },
  {
    label: _('i18n.DriverPlanning.List.Title'),
    link: 'driverplanning',
    icon: 'co_present',
    [RequiredScopes]: ['deployments:read'],
  },
];
